export const exampleInitialState = {
  customerName: "",
  loading: false,
  errorMessage: "",
  headerHide: false,
  timeZoneId: "act",
  realTimeGroup: [],
  realTimeGroupId: "",
  realTimeGroupName: "",
  reportAssetId:"",
  reportDate:"",
  reportAssetName:"",
  reportGroupId:"",
};
